import { render } from "./WalletDeposit.vue?vue&type=template&id=3065e2b9"
import script from "./WalletDeposit.vue?vue&type=script&lang=js"
export * from "./WalletDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__